import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../Formik'
import { UserSelect } from '../../../User'
import { getTaskManagers } from '../../Task.api'
import { TASK_EDIT_MANAGER_FIELDS_FIELD_NAME } from '../TaskEditManagerModal.constants'

function FormFields({ actionTypes, typeSelectProps }) {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{ ...typeSelectProps, options: actionTypes }}
      >
        <FormikField
          Component={FormFieldSelectNG}
          Field={FieldStackedLabel}
          Select={UserSelect}
          controlProps={{
            contentProps: {
              inputProps: {
                placeholder: t(
                  'Task.EditFormResponsibleManagerFieldPlaceholderKey'
                ),
              },
            },
          }}
          emptyValue={null}
          fieldComponentProps={{
            label: `${t('Task.EditFormResponsibleManagerFieldLabelKey')}:`,
          }}
          getData={getTaskManagers}
          getErrorProps={getFormikFormFieldErrorProps}
          name={TASK_EDIT_MANAGER_FIELDS_FIELD_NAME}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default FormFields
